export interface Customer {
  id: string,
  label: string
}
//TRUST PICKER
export const RETURN_CUSTOMER_CODE = "RETURN_CUSTOMER_CODE";
export const RETURN_CUSTOMER_CODE_FAIL = "RETURN_CUSTOMER_CODE_FAIL";
export interface GetCustomerCodeState {
  result: Customer[];
}

export interface GetCustomerCodeType {
  type: typeof RETURN_CUSTOMER_CODE | typeof RETURN_CUSTOMER_CODE_FAIL;
  payload:  Customer[];
}
export type ReturnCustomerCodeType = GetCustomerCodeType;
